import { Action } from '@ngrx/store';
import * as moment from 'moment';
import { ConcreteProposalOP, SlotsResponseOP } from '@cemex-core/cmx-api';
import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';
import { CwcTimeSlot } from '@ordersnproducts/modules/shared/models/dco/cwc-time-slot.model';
import { OrderStatusModify } from '../models/dco/order-status-modify-snapshot.model';
import { LargeOrderMessage } from '../reducers/dco.reducer';
import { WaitingListDeliveryTimeFlexibility } from '@ordersnproducts/modules/shared/modules/dco/models/waiting-list-delivery-time-flexibility.model';

export enum ActionTypes {
  SET_REQUEST_DATETIME = '[DCO] Set Request Datetime',
  SET_SELECTED_SLOT = '[DCO] Set selected slot',
  CHECK_WAITING_LIST = '[DCO] Check Waiting List',
  SET_WAITING_LIST_DELIVERY_TIME_FLEXIBILITY = '[DCO] Set Waiting List Delivery Time Flexibility',
  SELECT_DATETIME_SLOT = '[DCO] Select Datetime Slot',
  FETCH_SLOTS = '[DCO] Fetch Slots',
  FETCH_SLOTS_SUCCESS = '[DCO] Fetch Slots Success',
  FETCH_SLOTS_ERROR = '[DCO] Fetch Slots Error',
  DELETE_DATA = '[DCO] Delete Data',
  MARK_SLOT_AVAILABLE = '[DCO] Slot Available',
  RESET_SLOTS = '[DCO] Reset Slots',
  REMOVE_ITEM = '[DCO] Remove item',
  REMOVE_ITEM_SUCCESS = '[DCO] Remove item Success',
  SAVE_FORM_SNAPSHOT = '[DCO] Save Form Snapshot',
  DUMMY_FETCH_SLOTS_SUCCESS = '[DCO] Dummy Fetch Slot Success',
  FORMAT_DATA_FOR_CALENDAR_VIEW = '[DCO] Format data for calendar view',
  UNSHIFT_TIME_SLOTS = '[DCO] Unshift time slots',
  PUSH_TIME_SLOTS = '[DCO] Push time slots',
  FORMAT_DATA_FOR_CALENDAR_VIEW_SUCCESS = '[DCO] Format data for calendar view success',
  FETCH_SCHEDULE_DAYS = '[DCO] Fetch More Schedule Days',
  FETCH_SCHEDULE_DAYS_V2 = '[DCO] Fetch More Schedule Days V2',
  FETCH_SCHEDULE_DAYS_SUCCESS = '[DCO] Fetch More Schedule Days Success',
  FETCH_SCHEDULE_DAYS_ERROR = '[DCO] Fetch More Schedule Days Error',
  DELETE_MODIFY_ORDER_STATUS = '[DCO] DELETE ORDER MODIFY STATUS',
  SET_MODIFY_ORDER_STATUS = '[DCO] SET ORIGINAL ORDER STATUS',
  ORDER_MODIFY_HAVE_CHANGES = '[DCO] MODIFY order have changes',
  ORDER_MODIFY_COLOR_SPECIAL_SCENARIOS = '[DCO] MODIFY order color special scenarios',
  SAVE_CALL_DCO = '[DCO] Save Call DCO',
  RESET_CALL_DCO = '[DCO] Reset Call DCO',
  SAVE_DCO_IDS = '[DCO] Save DCO ids',
  FETCH_SLOTS_BIGO = '[DCO] Fetch Slots Bigo',
  FETCH_SLOTS_BIGO_RESET = '[DCO] Fetch Slots Bigo Reset',
  SAVE_SPECIAL_SCENARIOS_ACTIVE = '[DCO] Save Special Scenarios Active',
  REMOVE_SPECIAL_SCENARIOS_ACTIVE = '[DCO] Remove Special Scenarios Active',
  ACCEPT_LIABILITY_CHECK = '[DCO] Check Liability checkbox',
  SAVE_SLOTS_OUT_OF_SERVICE = '[DCO] Load Slots Out Of Service',
  SAVED_SLOTS_OUT_OF_SERVICE_CHECK = '[DCO] Load Slots Out Of Service Check',
  SAVED_SLOTS_OUT_OF_SERVICE_RESET = '[DCO] Load Slots Out Of Service Reset',
  REMOVE_ALL_ITEMS_EXCEPT = '[DCO] Remove all dco items except one of id payload',

  SAVE_RESPONSE_MESSAGE = '[DCO] Save Response Message',
  RESET_RESPONSE_MESSAGE = '[DCO] Reset Response Message',
  TRIGGER_RESET_WARNING_DCO = '[DCO] Trigger Reset Warning',
  ACCEPTED_RESET_WARNING_DCO = '[DCO] Accepted Reset Warning',
}

export class SetRequestDatetime implements Action {
  readonly type = ActionTypes.SET_REQUEST_DATETIME;
  constructor(public payload: { formIndex: number; formId: number; moment: moment.Moment; isAvailable?: boolean }) {}
}

export class CheckWaitingList implements Action {
  readonly type = ActionTypes.CHECK_WAITING_LIST;
  constructor(public payload: { formId: number; checked: boolean }) {}
}

export class SetWaitingListDeliveryTimeFlexibility implements Action {
  readonly type = ActionTypes.SET_WAITING_LIST_DELIVERY_TIME_FLEXIBILITY;
  constructor(
    public payload: {
      formId: number;
      waitingListDeliveryTimeFlexibility: WaitingListDeliveryTimeFlexibility;
    },
  ) {}
}

export class AcceptLiabilityCheck implements Action {
  readonly type = ActionTypes.ACCEPT_LIABILITY_CHECK;
  constructor(public payload: { formId: number; checked: boolean }) {}
}

export class SelectDatetimeSlot implements Action {
  readonly type = ActionTypes.SELECT_DATETIME_SLOT;
  constructor(public payload: { formId: number; moment: moment.Moment; isAvailable?: boolean }) {}
}

export class SetSelectedSlot implements Action {
  readonly type = ActionTypes.SET_SELECTED_SLOT;
  constructor(public payload: ConcreteProposalOP) {}
}

export class FetchSlots implements Action {
  readonly type = ActionTypes.FETCH_SLOTS;
  constructor(public payload: { formId: number; formIndex: number }) {}
}
export class FetchSlotsBigo implements Action {
  readonly type = ActionTypes.FETCH_SLOTS_BIGO;
  constructor(public payload: LargeOrderMessage) {}
}
export class FetchSlotsBigoReset implements Action {
  readonly type = ActionTypes.FETCH_SLOTS_BIGO_RESET;
  constructor() {}
}
export class FetchSlotsSuccess implements Action {
  readonly type = ActionTypes.FETCH_SLOTS_SUCCESS;
  constructor(public payload: { formId: number; response: SlotsResponseOP; formSnapshot: RecipeFormValues }) {}
}

export class FetchSlotsError implements Action {
  readonly type = ActionTypes.FETCH_SLOTS_ERROR;
  constructor(public payload: { formId: number; error: any; formSnapshot: RecipeFormValues }) {}
}

export class DeleteData implements Action {
  readonly type = ActionTypes.DELETE_DATA;
  constructor() {}
}

export class RemoveItem implements Action {
  readonly type = ActionTypes.REMOVE_ITEM;
  constructor(public payload: { formId: number; formIndex: number }) {}
}
export class RemoveItemSuccess implements Action {
  readonly type = ActionTypes.REMOVE_ITEM_SUCCESS;
  constructor() {}
}

export class MarkSlotAvailable implements Action {
  readonly type = ActionTypes.MARK_SLOT_AVAILABLE;
  constructor(public payload: { formId: number; isAvailable: boolean }) {}
}

export class ResetSlots implements Action {
  readonly type = ActionTypes.RESET_SLOTS;
  constructor(public payload: { formId: number }) {}
}

export class SaveFormSnapshot implements Action {
  readonly type = ActionTypes.SAVE_FORM_SNAPSHOT;
  constructor(public payload: { formId: number; formSnapshot: RecipeFormValues }) {}
}

export class DummyFetchSlotsSuccess implements Action {
  readonly type = ActionTypes.DUMMY_FETCH_SLOTS_SUCCESS;
  constructor(public payload: { formId: number; formSnapshot: RecipeFormValues }) {}
}

export class FormatDataForCalendarView implements Action {
  readonly type = ActionTypes.FORMAT_DATA_FOR_CALENDAR_VIEW;
  constructor(public payload: { formId: number }) {}
}

export class PushTimeSlots implements Action {
  readonly type = ActionTypes.PUSH_TIME_SLOTS;
  constructor(public payload: { formId: number; timeslots: CwcTimeSlot[] }) {}
}

export class UnshiftTimeSlots implements Action {
  readonly type = ActionTypes.UNSHIFT_TIME_SLOTS;
  constructor(public payload: { formId: number; timeslots: CwcTimeSlot[] }) {}
}

export class FetchScheduleDays implements Action {
  readonly type = ActionTypes.FETCH_SCHEDULE_DAYS;
  constructor(public payload: { formId: number; requestDatetime: moment.Moment }) {}
}

export class FetchScheduleDaysV2 implements Action {
  readonly type = ActionTypes.FETCH_SCHEDULE_DAYS_V2;
  constructor(public payload: { formId: number; requestDatetime: moment.Moment }) {}
}

export class FetchScheduleDaysSuccess implements Action {
  readonly type = ActionTypes.FETCH_SCHEDULE_DAYS_SUCCESS;
  constructor(public payload: { formId: number; response: CwcTimeSlot[] }) {}
}

export class FetchScheduleDaysError implements Action {
  readonly type = ActionTypes.FETCH_SCHEDULE_DAYS_ERROR;
  constructor(public payload: { formId: number; error: any }) {}
}
export class DeleteModifyOrderStatus implements Action {
  readonly type = ActionTypes.DELETE_MODIFY_ORDER_STATUS;
  constructor() {}
}

export class ModifyOrderHaveChanges implements Action {
  readonly type = ActionTypes.ORDER_MODIFY_HAVE_CHANGES;
  constructor(public payload: boolean) {}
}
export class ModifyOrderColorSpecialScenarios implements Action {
  readonly type = ActionTypes.ORDER_MODIFY_COLOR_SPECIAL_SCENARIOS;
  constructor(public payload: boolean) {}
}
export class SetOriginalOrderStatus implements Action {
  readonly type = ActionTypes.SET_MODIFY_ORDER_STATUS;
  constructor(public payload: OrderStatusModify) {}
}
export class SaveDcoIds implements Action {
  readonly type = ActionTypes.SAVE_DCO_IDS;
  constructor(public payload: string) {}
}

export class SaveCallDCO implements Action {
  readonly type = ActionTypes.SAVE_CALL_DCO;
  constructor(public payload: boolean) {}
}
export class ResetCallDCO implements Action {
  readonly type = ActionTypes.RESET_CALL_DCO;
  constructor() {}
}

export class SaveOutOfServiceSlots implements Action {
  readonly type = ActionTypes.SAVE_SLOTS_OUT_OF_SERVICE;
  constructor(public payload: { formId: number; active: boolean }) {}
}

export class CheckOutOfServiceSlots implements Action {
  readonly type = ActionTypes.SAVED_SLOTS_OUT_OF_SERVICE_CHECK;
  constructor(public payload: { formId: number; check: boolean }) {}
}

export class ResetOutOfServiceSlots implements Action {
  readonly type = ActionTypes.SAVED_SLOTS_OUT_OF_SERVICE_RESET;
  constructor() {}
}
/**
 * Remove all dco items except one of id payload
 */
export class RemoveAllItemsExcept implements Action {
  readonly type = ActionTypes.REMOVE_ALL_ITEMS_EXCEPT;
  constructor(public payload: number) {}
}

export class SaveResponseMessage implements Action {
  readonly type = ActionTypes.SAVE_RESPONSE_MESSAGE;
  constructor(public payload: string) {}
}

export class ResetResponseMessage implements Action {
  readonly type = ActionTypes.RESET_RESPONSE_MESSAGE;
  constructor() {}
}

export class TriggerResetWarningDCO implements Action {
  readonly type = ActionTypes.TRIGGER_RESET_WARNING_DCO;
  constructor(public payload: boolean) {}
}

export class AcceptedResetWarningDCO implements Action {
  readonly type = ActionTypes.ACCEPTED_RESET_WARNING_DCO;
  constructor(public payload: boolean) {}
}

export type Actions =
  | SetRequestDatetime
  | CheckWaitingList
  | SetWaitingListDeliveryTimeFlexibility
  | SelectDatetimeSlot
  | SetSelectedSlot
  | FetchSlots
  | FetchSlotsSuccess
  | FetchSlotsError
  | DeleteData
  | MarkSlotAvailable
  | ResetSlots
  | RemoveItem
  | RemoveItemSuccess
  | SaveFormSnapshot
  | DummyFetchSlotsSuccess
  | FormatDataForCalendarView
  | PushTimeSlots
  | UnshiftTimeSlots
  | FetchScheduleDays
  | FetchScheduleDaysV2
  | FetchScheduleDaysSuccess
  | FetchScheduleDaysError
  | SetOriginalOrderStatus
  | DeleteModifyOrderStatus
  | ModifyOrderColorSpecialScenarios
  | FetchSlotsBigo
  | FetchSlotsBigoReset
  | SaveDcoIds
  | ModifyOrderHaveChanges
  | SaveCallDCO
  | ResetCallDCO
  | AcceptLiabilityCheck
  | SaveOutOfServiceSlots
  | CheckOutOfServiceSlots
  | ResetOutOfServiceSlots
  | RemoveAllItemsExcept
  | SaveResponseMessage
  | ResetResponseMessage
  | TriggerResetWarningDCO
  | AcceptedResetWarningDCO;
